import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { useNavigate } from "react-router-dom";

export const SiteDropDownFrontel = ({
  showUserDropDown,
  navBarCollapsed,
}: {
  showUserDropDown: boolean;
  navBarCollapsed: boolean;
}) => {
  const navigate = useNavigate();

  const {
    siteOptionsFrontel,
    siteDropDownValueFrontel,
    setSiteDropDownValueFrontel,
    setCameraDropDownValueFrontel,
    setUserFiltersFrontel,
    setCameraOptionsFrontel,
    loadingSitesFrontel,
    getCamerasBySiteFrontel,
  } = useClipsStore();

  const siteIds = new Map();
  (siteOptionsFrontel || []).forEach((object: any) => {
    siteIds.set(object.name, object.id);
  });

  // Create a Set to track unique names and ensure we only add each name once
  const uniqueNames = new Set<string>();
  const options: string[] = [];

  // First pass: collect unique names
  (siteOptionsFrontel || []).forEach((object: any) => {
    if (!uniqueNames.has(object.name)) {
      uniqueNames.add(object.name);
      options.push(object.name);
    }
  });

  let sx: any;

  if (showUserDropDown && navBarCollapsed) {
    sx = { width: 175 };
  }

  if (showUserDropDown && !navBarCollapsed) {
    sx = { width: 150 };
  }

  if (!showUserDropDown && navBarCollapsed) {
    sx = { width: 240 };
  }

  if (!showUserDropDown && !navBarCollapsed) {
    sx = { width: 200 };
  }

  return (
    <div key="site_dropdown_frontel">
      <Autocomplete
        value={siteDropDownValueFrontel}
        disablePortal
        options={options}
        loading={loadingSitesFrontel}
        onChange={(event, value: any) => {
          if (value !== null) {
            const id = siteIds.get(value);
            setSiteDropDownValueFrontel(value);
            setCameraDropDownValueFrontel(null);
            getCamerasBySiteFrontel([id], navigate);
            setUserFiltersFrontel((previousState: any) => {
              return {
                ...previousState,
                site_ids: [siteIds.get(value)],
                camera_ids: [],
              };
            });
          } else {
            setSiteDropDownValueFrontel(value);
            setCameraDropDownValueFrontel(null);
            setCameraOptionsFrontel([]);
            setUserFiltersFrontel((previousState: any) => {
              return {
                ...previousState,
                site_ids: [],
                camera_ids: [],
              };
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Site"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingSitesFrontel ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            autoComplete="off"
            sx={sx}
          />
        )}
      />
    </div>
  );
};
